import { EDIT_CANDIDATE } from "screens/LoginRegistration/queries";
import { clientHelper } from "utils/graphQL";
import getData from "utils/getData";
import gql from "graphql-tag";

export const TOP_FAs = [
  {
    id: 148,
    name: "Telesales / Telemarketing",
    image: "fa-categories/telesales_telemarketing.svg"
  },
  {
    id: 51,
    name: "Operations Executive",
    image: "fa-categories/operations_executive.svg"
  },
  {
    id: 20,
    name: "Back Office Executive",
    image: "fa-categories/back_office_executive.svg"
  },
  {
    id: 53,
    name: "Sales / Business Development",
    image: "fa-categories/sales_or_bd.svg"
  },
  {
    id: 31,
    name: "Delivery Boy",
    image: "fa-categories/delivery_boy.svg"
  },
  {
    id: 37,
    name: "Customer Care",
    image: "fa-categories/customer_care.svg"
  },
  {
    id: 34,
    name: "Human Resource (HR)",
    image: "fa-categories/human_resource.svg"
  },
  {
    id: 36,
    name: "Admin Executive",
    image: "fa-categories/admin_executive.svg"
  },
  {
    id: 33,
    name: "Accountant",
    image: "fa-categories/accountant.svg"
  }
];

export const LIST_FUNCTIONAL_AREAS = gql`
  {
    listFunctionalAreas(first: 150) {
      totalCount
      edges {
        id
        name
        image
      }
    }
  }
`;

// export const onSubmitClick = async ({ selectedFAs, goNext, state, client }) => {
//   const { user } = state;
//   const FANameMapping = {};

//   const payload = {
//     functional_area_ids: selectedFAs
//       ? Object.keys(selectedFAs).map((item) => +item)
//       : []
//   };

//   const FaMapping = Object.keys(selectedFAs).map((item, index) => {
//     FANameMapping[`Candidate_FA${index + 1}`] = selectedFAs[+item].name;
//   });

//   pushClevertapProfile({
//     Identity: user.id,
//     ...FANameMapping
//   });

//   const { data, error } = await graphQLClientMutationHelper(client)({
export const onSubmitMutationHandler = async ({
  selectedFAList,
  user,
  client
}) => {
  const returnData = {};

  const payload = {
    fa_experience: selectedFAList.map((item) => {
      const result = {
        functional_area_id: +item.id,
        experience: 0
      };
      if (item.expId) {
        result.id = item.expId;
      }
      return result;
    }),
    functional_area_ids: selectedFAList.map((item) => +item.id)
  };

  const { data, error } = await clientHelper("mutate")(client)({
    mutation: EDIT_CANDIDATE,
    variables: {
      id: user.stakeholder.id,
      payload
    }
  });

  if (error) {
    returnData.error = error;
    return returnData;
  }

  const functionalAreas = getData(data, "mutate.edit.functional_areas");
  const faExperience = getData(data, "mutate.edit.fa_experience");

  if (functionalAreas) {
    const userData = {
      ...user,
      stakeholder: {
        ...user?.stakeholder,
        fa_experience: faExperience,
        functional_areas: functionalAreas
      }
    };
    returnData.data = userData;
  }

  return returnData;
};
